// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__2qeMW","range":"MonthRangeSwitch_range__1FYY4","disabled":"MonthRangeSwitch_disabled__2jLzH"};